import React from "react";
import { useNavigate } from "react-router-dom";
import { createUser } from "client/api/UsersApi";
import { PaperLayout } from "components/PaperLayout/PaperLayout";
import type { UserFormInputs } from "components/users/UserForm";
import { UserForm } from "components/users/UserForm";
import { UserRoutesMap } from "./UserRoutesMap";

export function AddUserFormPage() {
  const navigate = useNavigate();

  const onSubmit = async (params: UserFormInputs) => {
    const result = await createUser({
      email: params.email,
      firstName: params.firstName,
      lastName: params.lastName,
    });
    navigate(UserRoutesMap.detail(result.id).root);
  };

  return (
    <PaperLayout>
      <UserForm header="Create new user" onSubmit={onSubmit} />
    </PaperLayout>
  );
}
